import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import {
  BsBoxSeam, BsFileEarmark, BsFileEarmarkText, BsJournalText, BsListCheck,
  BsPeople, BsRobot, BsUiChecks,
} from 'react-icons/bs';

import AssistantSkills from '../../../../components/AssistantSkills';
import CostingsModelView from '../../../../components/CostingsModel/costingModel';
import CoquilleExpert from '../../../../components/Expert/CoquilleExpert';
import OrganizationFile from '../../../../components/OrganizationFile';
import Pdf from '../../../../components/Pdf';
import PersonManager from '../../../../components/Contact/personManager';
import ReportModelView from '../../../../components/ReportModel/reportModelView';
import TasksListModel from '../../../../components/TaskListModel';
import TasksModel from '../../../../components/TasksModel';

/**
 * Ce que l'organisation réutilise d'un dossier à l'autre.
 *
 * L'écran ne porte rien lui-même : il range les huit ateliers où l'on prépare
 * ce qui servira ensuite — gabarits, modèles, carnet d'adresses.
 */
const ATELIERS = [
  { cle: 'documents', libelle: 'Documents', Icone: BsFileEarmark,
    Composant: OrganizationFile,
    aide: "Les gabarits Word remplis avec les données d'un dossier." },
  { cle: 'pdf', libelle: 'Modèles PDF', Icone: BsFileEarmarkText,
    Composant: Pdf,
    aide: 'Les modèles de courrier, et les variables qu’ils acceptent.' },
  { cle: 'taches', libelle: 'Modèles de tâches', Icone: BsListCheck,
    Composant: TasksModel,
    aide: 'Une tâche type, prête à être posée sur un dossier.' },
  { cle: 'listes', libelle: 'Listes de tâches', Icone: BsUiChecks,
    Composant: TasksListModel,
    aide: "Une suite de tâches qu'on applique d'un coup à un dossier." },
  { cle: 'rapports', libelle: 'Modèles de rapport', Icone: BsJournalText,
    Composant: ReportModelView,
    aide: 'La trame des champs du rapport.' },
  { cle: 'chiffrage', libelle: 'Modèles de chiffrage', Icone: BsBoxSeam,
    Composant: CostingsModelView,
    aide: 'Des ensembles de lignes de prix, importables dans un poste.' },
  { cle: 'contacts', libelle: 'Carnet d’adresses', Icone: BsPeople,
    Composant: PersonManager,
    aide: 'Les personnes qu’on retrouve d’un dossier à l’autre.' },
  { cle: 'assistant', libelle: 'Recettes IA', Icone: BsRobot,
    Composant: AssistantSkills,
    aide: "Les questions toutes prêtes proposées par l'assistant." },
];

function ManagerOrganization() {
  const [atelier, setAtelier] = useState(ATELIERS[0].cle);
  const actif = ATELIERS.find((a) => a.cle === atelier) || ATELIERS[0];
  const { Composant } = actif;

  return (
    <CoquilleExpert titre="Gestionnaire" sous_titre={actif.aide}>
      <Tabs
        value={atelier}
        onChange={(_, valeur) => setAtelier(valeur)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ mb: 3, borderBottom: '1px solid', borderColor: 'divider' }}
      >
        {ATELIERS.map(({ cle, libelle, Icone }) => (
          <Tab key={cle} value={cle} label={libelle} icon={<Icone />}
               iconPosition="start" sx={{ minHeight: 48 }} />
        ))}
      </Tabs>

      {/* Seul l'atelier ouvert est monté : les monter tous déclencherait huit
          chargements à l'arrivée sur l'écran. */}
      <Box>
        <Composant />
      </Box>
    </CoquilleExpert>
  );
}

export default ManagerOrganization;
